// Typelizer digest 15e3a9aabee7fda7b75a8490d7fb87d9
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /learners/students/:student_id/classes/:class_id/withdrawals */
  create: (
    params: { studentId: string | number; classId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/learners/students/:student_id/classes/:class_id/withdrawals', params, options),
    method: 'post',
  }),
}
